import React, { useEffect, useState, useMemo } from "react";
import { Switch, Route } from "react-router-dom";
import ErrorPage from "../../src/components/JobApplication/Shared/ErrorPage"

// react-bootstrap components
import {
    Badge,
    Button,
    ButtonGroup,
    Card,
    Form,
    InputGroup,
    Navbar,
    Nav,
    Pagination,
    Container,
    Row,
    Col,
} from "react-bootstrap";
import { useSelector, useDispatch } from 'react-redux'

// core components
import Footer from "components/Footers/Footer.js";

import HRInductionWizard from "../views/Induction/HRInductionWizard";
import HSInductionWizard from "views/Induction/HSInductionWizard";
import OnboardingWizard from "views/Induction/OnboardingWizard";

function EmployeeOnboarding() {
    const dispatch = useDispatch()
    const user = useSelector((state) => state.user);

    return <div className="wrapper wrapper-full-page">
        <Switch>
          
            <Route path="/onboarding/hrInduction" render={(props) => <HRInductionWizard {...props} />} />
            <Route path="/onboarding/hsInduction" render={(props) => <HSInductionWizard {...props} />} />
            <Route path="/" render={(props) => <OnboardingWizard {...props} />} />
            <Route render={() => <ErrorPage />} />
        </Switch>
        <Footer />
    </div>
}

export default EmployeeOnboarding;
